import './css/styles.scss';

function catMenyOpen() {
	const toggles = document.querySelectorAll('.kategori-toggle');

	// ✅ Restore all previously opened categories
	const openCategories = JSON.parse(localStorage.getItem('openWooCategories') || '[]');
	console.log('Öppna kategorier från localStorage:', openCategories);
	openCategories.forEach(openId => {
		const target = document.getElementById(openId);
		if (target) {
			target.classList.add('is-open');

			const toggle = document.querySelector(`.kategori-toggle[data-target="${openId}"]`);
			if (toggle) {
				const icon = toggle.querySelector('.plus-icon');
				if (icon) icon.classList.add('rotate');
			}
		}
	});

	// ✅ Set up all toggles
	toggles.forEach(button => {
		button.addEventListener('click', function (e) {
			e.preventDefault();

			const targetId = this.getAttribute('data-target');
			const childContainer = document.getElementById(targetId);
			const icon = this.querySelector('.plus-icon');
			console.log('Klick på kategori-toggle:', targetId, childContainer, icon);

			if (!targetId || !childContainer) return;

			childContainer.classList.toggle('is-open');
			if (icon) icon.classList.toggle('rotate');

			// ✅ Get stored list from localStorage
			let stored = JSON.parse(localStorage.getItem('openWooCategories') || '[]');

			if (childContainer.classList.contains('is-open')) {
				if (!stored.includes(targetId)) {
					stored.push(targetId);
				}
			} else {
				stored = stored.filter(id => id !== targetId);
			}

			// ✅ Update localStorage
			localStorage.setItem('openWooCategories', JSON.stringify(stored));
		});
	});
}




function stickyCatMenu() {
			const catMenu = document.querySelector('.kategori-widget');
			const header = document.querySelector('header');

			if (!catMenu || !header) return;

			const updateMargin = () => {
				const headerHeight = header.offsetHeight;
				catMenu.style.top = `${headerHeight}px`;
			};

			updateMargin();
			window.addEventListener('resize', updateMargin); // Anpassar vid resize
}


// on dom ready
document.addEventListener('DOMContentLoaded', () => {
	console.log('DOM laddad – anropar catMenyOpen');
	catMenyOpen();
	stickyCatMenu();
});
